<template>
  <div class="success-cases-container">
    <div class="success-cases-title">
      <span class="title">成功案例</span>
      <a href="/academy/case/" class="more" target="_blank"
        @mouseenter="hoverImg = true"
        @mouseleave="hoverImg = false">
        更多
        <img src="../../../static/images/icon/login-icon/help_more_hover.svg"
          v-if="hoverImg">
        <img src="../../../static/images/icon/login-icon/help_more.svg"
          v-else>
      </a>
    </div>
    <div class="success-cases-content">
      <div v-for="content in contents" class="content" @click="go2Link(content)">
        <div class="img-style">
          <img :src="content.image">
        </div>
        <img class="img-icon" :src="content.icon">
        <!-- <div class="img-icon">{{tttt}}</div> -->
        <div class="content-title">{{content.title}}</div>
        <div class="blue-line"></div>
        <div class="content-title-sub">{{content.subTitle}}</div>
        <div class="content-title-tag">
          <a :href="content.link" v-for="tag in tags">
            {{tag.name}}
            <div class="vertical-line"></div>
          </a>
        </div>
        <div class="horizonal-line"></div>
        <div class="statistics">
          <div class="stat" v-for="item in content.dataArr">
            <div class="stat-num">{{item.value}}<span style="font-size: 12px;">{{item.unit}}</span></div>
            <div :class="['stat-title', {'margin-right-t': item.right}]">{{item.type}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './success-cases.scss'
</style>

<script>
  // export { default } from './success-cases.js'
  export default {
    data () {
      return {
        hoverImg: false,
        contents: [{
          title: '美团酒店',
          subTitle: '美团酒店比心大挑战撩爆抖音',
          icon: require('../../../static/images/icon/login-icon/meituan.svg'),
          image: require('../../../static/images/icon/login-icon/meituan.png'),
          link: '/academy/case/detail/?case_id=6609921631462621198',
          dataArr: [{
            value: '1.2',
            unit: '亿',
            type: '点赞量'
          }, {
            value: '801',
            unit: '万',
            type: '评论量',
            right: true
          }, {
            value: '334',
            unit: '万',
            type: '分享量',
            right: true
          }]
        }, {
          title: 'MICHAEL KORS',
          subTitle: 'MK联手抖音开启本土化创新营销',
          icon: require('../../../static/images/icon/login-icon/MK.svg'),
          image: require('../../../static/images/icon/login-icon/MK.png'),
          link: '/academy/case/detail/?case_id=6536176620728745997',
          dataArr: [{
            value: '2',
            unit: '亿',
            type: '播放量'
          }, {
            value: '850',
            unit: '万',
            type: '点赞量',
            right: true
          }]
        }, {
          title: '奇瑞捷豹路虎',
          subTitle: '奇瑞捷豹路虎打响精准投放闪电战',
          icon: require('../../../static/images/icon/login-icon/luhu.svg'),
          image: require('../../../static/images/icon/login-icon/luhu.png'),
          link: '/academy/case/detail/?case_id=6602122569141190664',
          dataArr: [{
            value: '1.4',
            unit: '亿',
            type: '曝光量'
          }, {
            value: '290',
            unit: '万',
            type: '点击量',
            right: true
          }, {
            value: '334',
            unit: '万',
            type: '分享量',
            right: true
          }]
        }],
        tags: [{
          name: '招商加盟',
          link: '#'
        }, {
          name: '提交表单',
          link: '#'
        }, {
          name: 'oCPM',
          link: '#'
        }]
      }
    },
    props: {
      lessons: {
        type: Array,
        default () {
          return [1,2,3]
        }
      }
    },
    mounted () {
    },
    methods: {
      go2Link (content) {
        window.open(content.link)
      }
    }
  }
</script>